// import { Filter } from '../../common/filter';
import {
  boolDialogCtrl
} from '../../../admin/modals';
// import {
//   AlertModalController
// } from '../alert-modal.component';
require('./filters-cut-editor-modal.component.scss');

export class FiltersCutEditorModalController {
  constructor(
    $scope,
    $modalInstance,
    $modal,
    globalAlert,
    cut,
    FiltersService,
    FilterResource,
    ErrorHandlerService,
    AlertModalService,
    $window,
  ) {
    this.scope = $scope;
    this.$modal = $modal;
    this.$modalInstance = $modalInstance;
    this.FilterResource = FilterResource;
    this.FiltersService = FiltersService;
    this.AlertModalService = AlertModalService;
    this.globalAlert = globalAlert;
    this.scope.cut = cut;
    this.scope.isSaving = false;
    this.scope.fitFilters = true;
    this.scope.cuttedFilters = this.findArrtibutedFilters();
    this.scope.filters = this.searchFilters('');
    this.needChange = {};
    this.scope.cancel = () => {
      $modalInstance.dismiss('cancel');
    };
    this.window = angular.element($window);
    this.window.bind('resize', () => {
      $('.modal-body1').height((window.innerHeight * 0.96 -
        $('.modal-header').outerHeight() -
        $('.col-headers').outerHeight() -
        $('.modal-footer').outerHeight()));
    });
    this.scope.toggleFitFilters = () => {
      this.scope.fitFilters = !this.scope.fitFilters;
      this.scope.filters = this.searchFilters(this.searchName);
    };
    this.scope.searchFilters = (searchName) => this.scope.filters = this.searchFilters(searchName);
    this.scope.objToArry = obj => Object.values(obj);
    this.scope.objLength = obj => Object.keys(obj).length;
    this.scope.addFilterToAttrebuted = flt => this.addFilterToAttrebuted(flt);
    this.scope.removeFilterFromAttrebuted = flt => this.removeFilterFromAttrebuted(flt);
    this.scope.needChange = flt => !!this.needChange[flt.filter.id];
    this.scope.saveFilters = () => this.saveFilters();
  }

  toggleNeedChange(flt) {
    if (this.needChange[flt.filter.id]) delete this.needChange[flt.filter.id];
    else this.needChange[flt.filter.id] = flt;
  }

  removeFilterFromAttrebuted(flt) {
    this.toggleNeedChange(flt);
    delete this.scope.cuttedFilters[flt.filter.id];
    this.scope.filters = this.searchFilters(this.searchName);
  }

  addFilterToAttrebuted(flt) {
    this.toggleNeedChange(flt);
    this.scope.cuttedFilters[flt.filter.id] = flt;
    this.scope.filters = this.searchFilters(this.searchName);
  }

  hasCut(filter) {
    if (filter.hasOwnProperty('filters')) {
      return filter.filters.some(attr =>
        attr.dimension === this.scope.cut.dimension &&
        attr.value === this.scope.cut.value);
    }
    return false;
  }

  searchFilters(searchName) {
    this.searchName = searchName;
    // if (searchName)
    // console.log(searchName);
    return this.findFiltres(filter =>
      !this.scope.cuttedFilters[filter.id] &&
      filter.name.toLowerCase().indexOf(searchName.toLowerCase()) !== -1 &&
      (!this.scope.fitFilters || filter.filters.some(cut => this.scope.cut.dimension === cut.dimension)));
  }

  findArrtibutedFilters() {
    return this.findFiltres(filter => this.hasCut(filter))
      .reduce((acc, flt) => {
        acc[flt.filter.id] = flt;
        return acc;
      }, {});
  }

  findFiltres(predicate) {
    const result = [];
    const findIter = (filters, parentId, level) => {
      filters.map(filter => {
        if (predicate(filter)) result.push({
          filter,
          parentId,
          level
        });
        if (filter.children && filter.children.length) {
          findIter(filter.children, filter.id, level + 1);
        }
      });
    };
    findIter(this.FiltersService.filters, null, 0);
    // console.log(this.scope);
    return result;
  }

  setCut(flt) {
    if (!flt.filter.hasOwnProperty('filters')) flt.filter.filters = [];
    flt.filter.filters.push({
      dimension: this.scope.cut.dimension,
      value: this.scope.cut.value,
      label: this.scope.cut.value,
      predicates: []
    });
  }

  removeCut(flt) {
    if (!flt.filter.filters) return;
    flt.filter.filters.find((attr, i, arr) => {
      if (attr.dimension === this.scope.cut.dimension &&
        attr.value === this.scope.cut.value) {
        arr.splice(i, 1);
        return true;
      } else return false;
    });
  }

  saveFilters() {
    this.scope.isSaving = true;
    const promices = [];
    for (const key in this.needChange) {
      promices.push(new Promise((resolve, reject) => {
        const flt = this.needChange[key];
        if (this.scope.cuttedFilters[key]) {
          this.setCut(flt);
        } else {
          this.removeCut(flt);
        }
        // console.log(flt);
        flt.error = null;
        flt.statis = null;
        this.saveFilter(flt, resolve, reject);
      }));

    }
    Promise.all(promices).then(res => {
      this.scope.isSaving = false;
      this.$modalInstance.close(null);
    });
  }


  saveFilter(flt, resolve, reject) {
    this.FilterResource.save(flt.filter, (status, data, error) => {
      flt.error = error;
      flt.statis = status;
      if (error) {
        this.globalAlert(error.message);
        console.error(error);
        reject(flt);
      } else {
        if (status === 200) {
          resolve(flt);
        }
        if (status === 422) {
          this.ErrorHandlerService.showErrorMessageBox(
            `${gettext('Ошибка')}: ${status}`,
            gettext('Заполните необходимые поля.')
          );
          // this.ErrorHandlerService.handleServerError({
          //   status: 422,
          //   data: gettext('Заполните необходимые поля.')
          // });
          reject(flt);
          // $scope.errors = data;
        }
      }
    });

  }
}



// WEBPACK FOOTER //
// ./src/filter/editor/cut-editor/filters-cut-editor-modal.component.js